import { ref as s, onMounted as t } from "vue";
const c = (r) => {
  const n = s(null);
  return t(async () => {
    if (r.value)
      try {
        const e = await (await fetch(r.value)).json();
        n.value = (e == null ? void 0 : e.link) ?? null;
      } catch (o) {
        console.error(o);
      }
  }), { lazyUrl: n };
};
export {
  c as useLazyUrl
};
